import * as React from 'react'
import { DropList, DropListProps } from '@amzn/dvui/dist/DropList'

const DROPLIST_PREFIX = 'av-droplist-'

interface elemDOM extends HTMLElement {
  checked: boolean
}

export const CloseableDropList = (props: DropListProps) => {
  const newLinks = props.links && props.links.map(dropListLink => ({
    ...dropListLink,
    onClick : (e: React.MouseEvent<HTMLElement>) => {
      const el = document.getElementById(`${DROPLIST_PREFIX}${props.customDropListID}`) as elemDOM
      if (el && el.checked) {
        // set false to toggle off the drop list
        el.checked = false
      }
      dropListLink.onClick(e)
    },
  }))
  const newProps = {...props, links: newLinks}
  return <DropList {...newProps} />
}